export interface UtenteDto {
  id: number;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  dataInizioValidita: Date;
  dataFineValidita: Date;
  ruoli: ApplicazioneRuoloDto[];
  aziendeDelegate: string[];
}

export interface ApplicazioneRuoloDto {
  applicazione: string;
  ruoli: RuoloDto[];
}

export interface RuoloDto {
    id: string;
    descrizione: string;
    applicazione: string;
}

export enum ApplicazioneEnum {
  COSTI = 'COSTI',
  AUAAL_CLIENT = 'AUAAL_CLIENT'
}

export enum RuoloEnum {
  AUAAL_AMMINISTRATORE = 'AUAAL_AMMINISTRATORE',
  AUAAL_FUNZIONARIO_REGIONALE = 'AUAAL_FUNZIONARIO_REGIONALE',
  AUAAL_FUNZIONARIO_COMUNALE = 'AUAAL_FUNZIONARIO_COMUNALE',
  AUAAL_FORZE_ORDINE = 'AUAAL_FORZE_ORDINE'
}
